export default "__VITE_ASSET__B3Gf8pnT__"